<template lang="pug">
.donation-success
	VueFeedback(type="success")
		template(slot="feedback-title") Thank you so much for your donation!
		template(slot="feedback-content")
			p.sf-text SimplePay transaction identifier:
				strong  {{transactionId}}
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	props: {
		transactionId: {
			required: true
		}
	},
	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>

<style lang="scss" scoped>
.donation-success {
	margin-bottom: 48px;
}
</style>
